import CustomElementRegistry from './CustomElementRegistry';

export default {
  __init__: ['elementRegistry'],
  elementRegistry: ['type', CustomElementRegistry]
};
